<template>
  <div class="box">
    <!-- 头部 -->
    <div class="head">
      <div class="head-bx">
        <div class="top">
          <img src="@/assets/logo.png" alt="" />
          <p>新疆维吾尔自治区气候中心长期预测平台</p>
        </div>
        <div class="centent">
          新疆气候中心智能中长期预测是一个基于多种人工智能算法的预测平台，主要用于预测新疆未来15-60天的天气情况。根据预测结果，可以提前做好风沙和低温灾害的各项防御工作。其中算法包括国内先进的Pangu-大模型，以及欧洲中心的fourtercast以及微软司的graphcast图神经预训练大模型，再次基础上加入多种本地合算子以及基于dfhusionmodel的先进
          降尺度算法，本平台支持新疆和西北地区的精细化中长期预测服务和企业的气候评估可研技术支持
        </div>
        <div class="btn">
            开始使用
        </div>
      </div>
    </div>
    <h5 class="hang">
        气象预测
    </h5>
     <!-- 气象预测 -->
    <algorithm></algorithm>
   
     <h5 class="hang">
        单位<span style="color:#2d5a9d">主要先进业务</span>展示
    </h5>
    <div class="zhuyao">
        <div class="dbox">
            <div class="imga">
                <img src="@/assets/bgc1.png" alt="">
                <div class="ding">
                    <p class="dingp">pangu中长期预测服务</p>
                    <div class="dingm">
                        这是一段描述文本
                    </div>
                    <div class="dingl">
                        了解更多 &gt;
                    </div>
                </div>
            </div>
             <div class="imgb">
                <img src="@/assets/bgc1.png" alt="">
                <div class="dingb">
                    <p class="dingp">pangu中长期预测服务</p>
                    <div class="dingm">
                        这是一段描述文本
                    </div>
                    <div class="dingl">
                        了解更多 &gt;
                    </div>
                </div>
            </div>
             <div class="imgc">
                <img src="@/assets/bgc1.png" alt="">
                <div class="dingc">
                    <p class="dingp">pangu中长期预测服务</p>
                    <div class="dingm">
                        这是一段描述文本
                    </div>
                    <div class="dingl">
                        了解更多 &gt;
                    </div>
                </div>
            </div>
        </div>
       <div class="anniu">
         <div class="btns">
            全部业务
        </div>
       </div>
    </div>
    <h5 class="hang" style="background-color: #fff;">
        单位地点
    </h5>
    <div class="dizhi">
        <div class="dizhimine">
            <img src="@/assets/ditu.png" alt="">
            <div class="dzding">
                <div class="top">
                    <img src="@/assets/logo.png" alt="" style="width:20px;height:20px"/>
                    新疆维吾尔自治区气候中心
                </div>
                <p>地点：新疆维吾尔自治区乌鲁木齐市天山区建国路327号</p>
                <p>邮箱：xxx@xxx.com</p>
                 <div class="tops">
                    <img src="@/assets/logo.png" alt="" style="width:20px;height:20px"/>
                    1008611
                </div>
            </div>
        </div>
    </div>
    <div class="foot">
         <img src="@/assets/logo.png" alt="" >
            <span>@2023-2026新疆维吾尔自治区气候中心版权所有</span>
            <span>ICP备201464484号-2</span>
            <span>经营许可证编号:合字B2-2494848</span>
            <img src="@/assets/logo.png" alt="" style="margin-right: 2px;">
             <span>XX网安备441544564号</span>
    </div>
  </div>
</template>

<script>
import algorithm from './algorithm.vue'
export default {
    components:{algorithm},
  data() {
    return {};
  },

  mounted() {},

  methods: {},
};
</script>

<style scoped>

.box{
    background-color: #f0f0f0;
}
.head {
  width: 100%;
  /* height: 400px; */
  background: url("@/assets/bgc1.png");
  background-size: 100% 100%;
  padding: 50px 0;
  box-sizing: border-box;
}
.zhuyao {
  width: 100%;
  /* height: 400px; */
  background: url("@/assets/bgc2.png");
  background-size: 100% 100%;
  padding: 50px 0;
  box-sizing: border-box;
}
.dizhi{
  width: 100%;
  background: url("@/assets/bgc3.png") no-repeat;
  background-size: contain;
  padding: 30px 0;
  box-sizing: border-box;   
  background-color: #fff;
}
.head .head-bx {
  width: 1400px;
  margin: 0 auto;
}
.head .head-bx .top {
  display: flex;
  font-size: 2.5rem;
  letter-spacing:3px;
  color: #fff;
  align-items: center;
}
.head .head-bx .top img {
  width: 35px;
  margin-right: 10px;
}
.head .head-bx .centent {
  width: 70%;
  margin: 20px 0;
  font-size: 1rem;
  color: #fff;
  line-height: 30px;
}
.btn{
    display: inline-block;
    padding: 10px 20px;
    color: #fff;
    font-size: 1rem;
    background-color: #2d5b99;
}
.anniu{
    width: 100%;
    text-align: center;
    margin-top: 20px;
}
.btns{
     display: inline-block;
    padding: 10px 20px;
    color: #2d5b99;
    font-size: 1rem;
   border: 1px solid #2d5b99;
   
   cursor: pointer;
}
.hang{
    width: 100%;
    text-align: center;
    color: #000;
     font-size: 2.5rem;
     font-weight: normal;
     letter-spacing:3px;
     padding: 20px 0;
}
.zhuyao .dbox{
    width: 1200px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
}
.zhuyao .dbox .imga,.imgb,.imgc{
    width: 32%;
    height: 180px;
    position: relative;
    overflow: hidden;
    cursor: pointer;
}
.zhuyao .dbox .imga:hover .ding{
    top: 0;
}
.zhuyao .dbox .imgb:hover .dingb{
    top: 0;
}
.zhuyao .dbox .imgc:hover .dingc{
    top: 0;
}
.ding,.dingb,.dingc{
    width: 100%;
    height: 100%;
    background-color: #0071ff73;
    position: absolute;
    top: 100%;
    left: 0;
    transition: .5s;
    padding: 20px;
    color: #fff;
    opacity: 0.8;
}
.dingp{
    font-size: 1.2rem;
    letter-spacing:3px;
    font-weight: bold;
}
.dingm{
    margin-top: 20px;
    height: 80px;
    font-size: 14px;
}
.dingl{
    font-size: 13px;
}
.zhuyao .dbox img{
    width: 100%;
    height: 100%;
    object-fit: cover;
}
.dizhimine{
    width: 800px;
    margin: 0 auto;
    height: 400px;
    position: relative;
}
.dizhimine img{
    width: 100%;
    height: 100%;
    object-fit: cover;
}
.dzding{
    position: absolute;
    top: 10px;
    left: 10px;
    background-color: #fff;
    width: 40%;
    padding: 10px;
}
.dzding .top{
    display: flex;
    align-items: center;
    color: #000;
    font-weight: 550;
    letter-spacing:3px;
    font-size: 14px;
    margin-bottom: 15px;
}
.dzding .top img{
    margin-right: 5px;
}
.dzding .tops{
    display: flex;
    align-items: center;
    color: #000;
    font-weight: 500;
    font-size: 12px;
}
.dzding .tops img{
    margin-right: 5px;
}
.dzding  p{
    font-size: 12px;
    color: rgb(110, 110, 110);
    line-height: 20px;
}
.foot{
    width: 800px;
    margin: 0 auto;
    padding: 5px 0;
    display: flex;
    align-items: center;
    font-size: 12px;
    color: rgb(110, 110, 110);
    justify-content: space-around;
}
.foot img{
width:20px;
margin-right: 5px;
}
.foot span{
margin-right: 8px;
}
</style>